import { error } from '@sveltejs/kit';

/** @type {import('./$types').LayoutLoad} */
export async function load({ url }) {
	const dataFilters = ['isFrom', 'date', 'nbPersons'];
	let bq = {};
	let theme = '';
	let restaurantToken = '';

	for (const [key, value] of url.searchParams) {
		const match = key.split('-')[1];
		if (key.startsWith('data-') && dataFilters.includes(match))
			Object.assign(bq, { [match]: value });
		if (key.toLowerCase() === 'theme') theme = value;
		if (key.toLowerCase() === 'restauranttoken') restaurantToken = value;
	}
	if (!theme) theme = 'default';

	if (!restaurantToken) throw error(400, { message: 'Missing restaurant token' });

	return { bq, theme, restaurantToken, search: url.search };
}

export const prerender = false;
